import { ConfirmationDialog } from "../../../assets/types";
import { Constants } from "../../../assets/utils/lib/constants";
import { LoadingIndicator } from "../../../assets/vfx";
import { VfxDialogProps } from "../../../assets/vfx/dialog/vfxDialogProps";
import Drawer from "../../../assets/vfx/drawer/drawer";
import { RssFeedDto } from "../../../services/dto";
import DisplayData from "../../common/DisplayData/DisplayData";
import { RssFeedLookupProps } from "./rssFeedForm";

interface RssFeedViewProps {
  data?: RssFeedDto;
  show: boolean;
  onHide: () => void;
  onEdit: () => void;
  onDelete: () => void;
  lookups?: RssFeedLookupProps;
  title: string;
}

export const RssFeedView = (props: RssFeedViewProps) => {
  const community: string | undefined = props.lookups?.communities.find(
    (x) => x.value === props.data?.communityId
  )?.display;

  const rssFeedType: string | undefined = props.lookups?.rssFeedType.find(
    (x) => x.value === props.data?.rsSfeedTypeId
  )?.display;

  const modalDialogProps: VfxDialogProps | undefined =
    new ConfirmationDialog().get(props.onDelete, "Delete", {
      Name: props.data?.name ?? Constants.emptyString,
    });

  return (
    <Drawer.View
      className="w-30"
      show={props.show}
      backdrop={true}
      placement="end"
      scroll={true}
      onHide={props.onHide}
      onEdit={props.onEdit}
      title={`View ${props.title}`}
      onDelete={props.onDelete}
      modalDialogProps={modalDialogProps}
    >
      {!props.data ? (
        <LoadingIndicator isFullPage />
      ) : (
        <>
          <DisplayData text="Name" importedData={props.data?.name} />
          <DisplayData
            text="Description"
            importedData={props.data?.description}
          />
          <DisplayData text="Community" importedData={community} />
          <DisplayData text="Rss Feed Type" importedData={rssFeedType} />
                      {/*<DisplayData text="Url" importedData={props.data?.url} />
          {props.data?.baseUrlLink && (
            <DisplayData
              text="BaseUrl Link"
              importedData={props.data?.baseUrlLink}
            />
          )}
          <DisplayData
            text="Max Display"
            importedData={props.data?.maxDisplay}
          />
          <DisplayData
            text="Highlight Display Count"
            importedData={props.data?.highlightDisplayCount}
          />*/}
        </>
      )}
    </Drawer.View>
  );
};
